var _rect, _rect2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoqqDialogHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 80,
    viewBox: "0 0 350 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9.86328,
    width: 350,
    height: 70.137,
    rx: 16,
    fill: "#322892"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 348.75,
    height: 68.887,
    rx: 15.375,
    fill: "url(#paint0_linear_9784_147385)",
    stroke: "url(#paint1_linear_9784_147385)",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9784_147385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.73438 32.0195C2.73438 32.0195 21.5686 27.2005 20.4856 32.0582C19.4026 36.9159 12.8775 46.7683 20.0036 49.0307C27.1297 51.2931 30.4205 50.5432 35.5679 51.8732C40.7153 53.2032 29.7808 67.2223 29.7808 67.2223",
    stroke: "#B49BF2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_9784_147385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.662 41.415C347.662 41.415 328.321 44.0723 330.052 39.3739C331.782 34.6755 339.587 25.6346 332.821 22.5855C326.055 19.5364 322.688 19.9093 317.759 18.0087C312.831 16.1081 325.574 3.42985 325.574 3.42985",
    stroke: "#B49BF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9784_147385",
    x: 0.580078,
    y: 27.4033,
    width: 38.8789,
    height: 42.1182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_9784_147385"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9784_147385",
    x: 314.117,
    y: 1.08008,
    width: 35.6367,
    height: 43.5752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_9784_147385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9784_147385",
    x1: 175,
    y1: -23.75,
    x2: 175,
    y2: 70.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166319,
    stopColor: "#FF2F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A21CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9784_147385",
    x1: 175,
    y1: 0,
    x2: 175,
    y2: 70.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FFF3",
    stopOpacity: 0.168675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#F5FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7065D6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoqqDialogHeader);
export default __webpack_public_path__ + "static/media/roqq-dialog-header.a46ddbaae66c2305390668b9e809830f.svg";
export { ForwardRef as ReactComponent };